import React from "react";

const MicrosoftChannelIcon = ({
  color,
  className,
}: {
  color: string;
  className?: string;
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M7 1.5H1.5V7H7V1.5Z" fill={color} />
      <path d="M14.5 1.5H9V7H14.5V1.5Z" fill={color} />
      <path d="M7 9H1.5V14.5H7V9Z" fill={color} />
      <path d="M14.5 9H9V14.5H14.5V9Z" fill={color} />
    </svg>
  );
};

export default MicrosoftChannelIcon;
